import React, { useState,useEffect } from "react"

const CaseStudies = ({ caseStudy,caseStudiesHeading }) => {
  const caseUrl = typeof window !== 'undefined' ? window.location.pathname : '';
  const [url, setUrl] = useState(caseUrl)
  const [showFilter,setShowFilter] = useState(false)

  const updatePosts=(e)=>{

  // insightItems.pop();
  if(url==="/careers/case-studies/"){
      setShowFilter(true)

    }
  }
  useEffect(() => {

    updatePosts()
  }, []);

  return (
    <>
    {caseStudiesHeading ?
    <section className="content">
   <div className="eighty-spacer"></div>

   <div className="content-block clearfix">

      <div className="centered-intro-title-holder">
         <h1>
            {caseStudiesHeading}        </h1>
      </div>

   </div>
   <div className="eighty-spacer"></div>
</section>
:null}
    <section className="content case-study-blocks hide-on-responsive">
    {caseStudy.length
      ? caseStudy.map((cat,index) => (
        <ul className="case-studies-mixitup one-flex-container" id="MixItUp24C050" key={index}>
        {cat.caseStudies.nodes.map((download,index) =>(
          <li className="mix case-study-mix-block half-flex-container" style={{display: "flex"}} data-bound="" key={index}>
          <div className="full-width-news-content">
                    <h3>{download.title}</h3>
                    {showFilter ?
                    <span dangerouslySetInnerHTML={{ __html: download.excerpt }}/>
                    :null}
                      <div className="find-out-more">
                       <a href={`/case-study/${download.slug}`}>
                            Find out more
                        </a>
                    </div>
                 </div>


              </li>

        ))}
        </ul>
      ))
    : null}
    <div className="eighty-spacer">
    </div>

    </section>
    </>
  )
}

export default CaseStudies
